module.exports = [{"value":"MAS_APP_202131591255439","text":"แยกทาง"},{"value":"MAS_APP_202131591242319","text":"เป็นหม้าย"},{"value":"MAS_APP_202131591126247","text":"หย่า"},{"value":"MAS_APP_202131591047535","text":"แต่งงานแล้ว"},{"value":"MAS_APP_20213159954784","text":"โสด"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/MaritalStatus/maritalStatusTH.json
// module id = PWuB
// module chunks = 2